import * as _ from "lodash";
import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "../Hedron";
import { Text } from "../Text";

interface StaticTableProps {
  headers?: string[];
  bodyRows: Array<Array<JSX.Element | string>>;
  centerCellContent?: boolean;
}

/**
 * Logo and colors page
 *
 * @returns
 */
const StaticTable: React.ReactFCWithChildren<StaticTableProps> = ({
  headers, bodyRows, centerCellContent = true
}) => {
  return (
    <Grid.Provider>
      <TContent>
        {headers && (
          <Grid.Bounds
            direction="horizontal"
            wrap={1}
          >
            {headers.map((header, index) => (
              <TCell
                key={`body-row-${index}`}
                className={centerCellContent && index > 0 ? "center-cell-content" : ""}
              >
                <Text weight="bold">
                  {header}
                </Text>
              </TCell>
            ))}
          </Grid.Bounds>
        )}

        <TBody>
          {bodyRows.map((bodyRow, index) => (
            <TBodyRow
              key={`body-row-${index}`}
              className={index % 2 === 0 ? "odd" : "even"}
            >
              {bodyRow.map((cell, ind2) => (
                <TCell
                  key={`body-cell-${ind2}`}
                  className={centerCellContent && ind2 > 0 ? "cell-content center-cell-content" : "cell-content"}
                >
                  {cell}
                </TCell>
              ))}
            </TBodyRow>
          ))}
        </TBody>
      </TContent>
    </Grid.Provider>
  );
};

const TContent = styled(Grid.Bounds).attrs({ direction: "vertical" })`
  .center-cell-content {
    display: flex;
    justify-content: center;
  }
`;

const TBody = styled(Grid.Bounds).attrs({ direction: "vertical" })`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
`;

const TBodyRow = styled(Grid.Bounds).attrs({
  direction: "horizontal",
  wrap: 1
})`
  ${({ theme }) => css`
    &:first-child {
      border-top: 1px solid ${theme.colors.ziggurat};
      margin-top: ${theme.spacing.padding.sm};
    }

    border-bottom: 1px solid ${theme.colors.ziggurat};
    padding: ${theme.spacing.padding.sm} 0;
  `}
`;

const TCell = styled(Grid.Box)`
  flex: 1 1 0px;
  display: flex;
  align-items: center;

  .select-box {
    padding: 0;
    
    select {
      min-width: 180px;
    }
  }
`;

export default StaticTable;
